import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ─── Registro del Service Worker (PWA) ───────────────────────────────────────
// Activa el modo offline, caché inteligente y la posibilidad de instalar la app.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registrado:', registration.scope);

        // Verificar actualizaciones cada 30 segundos mientras la app está abierta
        setInterval(() => {
          registration.update();
        }, 30_000);
      })
      .catch((err) => {
        console.error('[PWA] Error al registrar el Service Worker:', err);
      });
  });

  // Cuando el nuevo Service Worker toma el control (al hacer deploy), recargar en silencio
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

// ─── Solicitar almacenamiento persistente ─────────────────────────────────────
// Esto le pide al navegador que NO borre los datos de IndexedDB automáticamente.
// El usuario podría verlo como "¿Permitir almacenamiento persistente?" en algunos browsers.
if (navigator.storage && navigator.storage.persist) {
  navigator.storage.persist().then((granted) => {
    if (granted) {
      console.log('[PWA] Almacenamiento persistente concedido ✓');
    } else {
      console.warn('[PWA] Almacenamiento persistente NO concedido — los datos pueden borrarse en dispositivos con poco espacio');
    }
  });
}